/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Hide_Event_AriaInputs */

const en_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Event Shortcut`)
};

const fr_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourci masquer l'evenement`)
};

const de_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfung zum Ereignis ausblenden`)
};

const it_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi collegamento evento`)
};

const ru_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть ярлык события`)
};

const es_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar acceso directo a eventos`)
};

const zh_cn2_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏事件快捷方式`)
};

const ja_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントのショートカットを非表示`)
};

const hi_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट शॉर्टकट छिपाएँ`)
};

const pt_pt2_timing_sync_hide_event_aria = /** @type {(inputs: Timing_Sync_Hide_Event_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atalho para ocultar evento`)
};

/**
* | output |
* | --- |
* | "Hide Event Shortcut" |
*
* @param {Timing_Sync_Hide_Event_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_hide_event_aria = /** @type {((inputs?: Timing_Sync_Hide_Event_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Hide_Event_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_hide_event_aria(inputs)
	if (locale === "de") return de_timing_sync_hide_event_aria(inputs)
	if (locale === "it") return it_timing_sync_hide_event_aria(inputs)
	if (locale === "ru") return ru_timing_sync_hide_event_aria(inputs)
	if (locale === "es") return es_timing_sync_hide_event_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_hide_event_aria(inputs)
	if (locale === "ja") return ja_timing_sync_hide_event_aria(inputs)
	if (locale === "hi") return hi_timing_sync_hide_event_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_hide_event_aria(inputs)
	return en_timing_sync_hide_event_aria(inputs)
});